import { Fragment, useState } from "react"
import {
  Button,
  Card,
  Input,
  PaginationData,
  Loading,
  TableNumber,
  HeaderMenu,
  BaseTable,
  TableHeaderSort,
  FooterMenu,
} from "../../../../components"
import { TbChevronRight } from "react-icons/tb"
import {
  RenderProvider,
  useColumnConfig,
  useExportList,
  useList,
} from "./utils"
import { useNavigate } from "react-router-dom"
import debounce from "lodash/debounce"
import { PaginationState } from "types"
import { default_pagination_value } from "utils"
import { PersonalList } from "./types"
import {
  Delete,
  Detail,
  Update,
} from "./components/ChildItem/components/Item/components"
import { IsActive } from "./components/ChildItem/components/Item/components/IsActive"
import FilterTable from "./components/FilterTable"
import { defaultValue, exportExcel } from "./utils/function"
import { useExportPdf } from "./utils/hooks"
import { PERMISION } from "security"

type headerState = { title: string; sort: boolean; align?: "left" | "right" }

export default function CreateNewCustomer(props: { tab?: string }) {
  const [pagination, setPagination] = useState<PaginationState>(
    default_pagination_value,
  )
  const { data, isLoading, refetch } = useList(pagination)
  const customers = useExportList()
  const exportPdf = useExportPdf({ data: customers.data })
  const onDebounce = debounce((e: any) =>
    setPagination((prev) => {
      return { ...prev, keyword: e.target.value }
    }),
  )
  const dataList: PersonalList[] = data.items
  const { dataColumn, refetchColumn } = useColumnConfig()

  const dataLength = data.pagination_data.size
  const pageCurrent = pagination.page
  const limit = pagination.limit
  const totalData = pagination.total

  const dataFillter = defaultValue(dataColumn)

  const header: headerState[] = [
    { title: "ID CUSTOMER", sort: true },
    { title: "CUSTOMER", sort: true },
  ]

  const sortMapping: Record<string, string> = {
    "ID CUSTOMER": "code",
    CUSTOMER: "name",
  }
  const handleSort = (item: string, sortType: string) => {
    const sortParam = sortMapping[item]
      ? `${sortMapping[item]}:${sortType}`
      : ""
    setPagination({ ...pagination, sort: sortParam, page: 1 })
  }

  const countTrueValues = (obj: Record<string, boolean | undefined>): number => {
    return Object.values(obj).filter(value => value === true).length;
  }
  const trueCount = countTrueValues(dataFillter);

  return (
    <section className="my-5">
      {props?.tab !== "tab" && (
        <HeaderMenu title="DATA ENTRY | CREATE NEW CUSTOMER" />
      )}
      <RenderProvider>
        <section className="my-2">
          <div className="sticky top-[125px] py-4 z-[2] bg-white dark:bg-black">
            <Card>
              <Card.Body>
                <div className="flex justify-between items-end">
                  <div className="flex gap-2 mb-3 items-center">
                    <div>
                      <Input
                        label="SEARCH"
                        className="lg:w-[300px] md:w-full"
                        placeholder="Search data..."
                        onChange={onDebounce}
                      />
                    </div>
                    <div className="mt-8">
                      <FilterTable dataList={dataColumn} refetch={refetchColumn} />
                    </div>
                  </div>
                  <div>
                  <Create />
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>
          <div className="overflow-x-auto max-h-[calc(100vh-600px)]">
            <BaseTable className="border-collapse w-full mt-2">
              <thead className="sticky top-0 pt-1 z-[1] !bg-black !text-white">
                <tr>
                  <th>NO</th>
                  <TableHeaderSort
                    title={header}
                    onSort={(item, sortType) => handleSort(item, sortType)}
                  />
                  {dataFillter.handphone && <th>HANDPHONE</th>}
                  {dataFillter.email && <th>EMAIL</th>}
                  {dataFillter.cardLabel && <th>CARD LABEL</th>}
                  {dataFillter.category && <th>CATEGORY</th>}
                  {dataFillter.priceLevel && <th>PRICE LEVEL</th>}
                  {dataFillter.bank && <th>BANK</th>}
                  {dataFillter.bankAccount && <th>BANK ACCOUNT</th>}
                  {dataFillter.country && <th>COUNTRY</th>}
                  {dataFillter.province && <th>PROVINCE</th>}
                  {dataFillter.regency && <th>REGENCY</th>}
                  {dataFillter.subdistrict && <th>SUBDISTRICT</th>}
                  {dataFillter.village && <th>VILLAGE</th>}
                  {dataFillter.address && <th>ADDRESS</th>}
                  <th className="w-[100px]">ACTION</th>
                </tr>
              </thead>

              <tbody>
                {isLoading || dataList.length === 0 ? (
                  <tr>
                    <td colSpan={9} className="text-center">
                      <Loading
                        loading={isLoading}
                        errorText="No data available"
                      />
                    </td>
                  </tr>
                ) : (
                  <Fragment>
                    {dataList.map((item, key) => (
                      <tr className="font-normal" key={key}>
                        <td>
                          {TableNumber({
                            dataLength: dataLength,
                            pageCurrent: pageCurrent,
                            index: key,
                            limit: limit,
                            totalData: totalData,
                          })}
                        </td>
                        <td>{item.customer_code}</td>
                        <td>{item.customer_name}</td>
                        {dataFillter.handphone && <td>{item.handphone}</td>}
                        {dataFillter.email && <td>{item.email}</td>}
                        {dataFillter.cardLabel && (
                          <td>
                            {item.card_label === 1 ? "Individu" : "Company"}
                          </td>
                        )}
                        {dataFillter.category && (
                          <td>{item.category_customer_name}</td>
                        )}
                        {dataFillter.priceLevel && (
                          <td>{item.price_level_name}</td>
                        )}
                        {dataFillter.bank && <td>{item.bank_name}</td>}
                        {dataFillter.bankAccount && (
                          <td>{item.bank_account}</td>
                        )}
                        {dataFillter.country && (
                          <td>{item.country_name}</td>
                        )}
                        {dataFillter.province && (
                          <td>{item.province_name}</td>
                        )}
                        {dataFillter.regency && (
                          <td>{item.regency_name}</td>
                        )}
                        {dataFillter.subdistrict && (
                          <td>{item.subdistrict_name}</td>
                        )}
                        {dataFillter.village && (
                          <td>{item.village_name}</td>
                        )}
                        {dataFillter.address && <td>{item.address}</td>}
                        <td className="flex">
                          <Detail id={item} />
                          <Update id={item} />
                          <Delete id={item} refetch={refetch} />
                          <IsActive id={item} refetch={refetch} />
                        </td>
                      </tr>
                    ))}
                  </Fragment>
                )}
              </tbody>

              <tbody style={{ border: "none" }} className="!border-none">
                <tr>
                  <td colSpan={4 + trueCount} className="border-0 !border-none !p-0" style={{ border: "none", padding: 0 }}>
                    <Card className="mt-5">
                      <Card.Body>
                        <div className="mt-[-20px]">
                          <PaginationData
                            data={data}
                            pagination={pagination}
                            setPagination={setPagination}
                          />
                        </div>
                      </Card.Body>
                    </Card>

                    <section className="mt-2">
                      <FooterMenu
                        export={{
                          actiontype: "export",
                          onClick: () => exportExcel({ data: customers.data }),
                        }}
                        pdf={{
                          actiontype: "pdf",
                          onClick: exportPdf.handleExportPdf,
                        }}
                      />
                    </section>
                  </td>
                </tr>
              </tbody>
            </BaseTable>
          </div>
        </section>
      </RenderProvider>
    </section>
  )
}

function Create() {
  const navigate = useNavigate()
  return (
    <Fragment>
      <Button
        permission={PERMISION.CARDS.REGISTER.CUSTOMER.CREATE}
        color="primary"
        onClick={() =>
          navigate("/cards/transaction/create-new-customer/create")
        }
        className="mb-4"
      >
        CREATE NEW <TbChevronRight />
      </Button>
    </Fragment>
  )
}

